import React from 'react';
import SliderSolo from './SliderSolo';

function KnobSet(props) {
    const att = Object.keys(props.attributes);

    return (
        // <div className='flex-inline justify-center'>
            <div className='sm:flex md:flex-inline md:pl-0 lg:-ml-0'>
                <div className='flex-inline mt-6 -space-y-2'>
                    {att.slice(0,18).map((attribute, index)=>(
                        <SliderSolo key={index}
                                    name={attribute}
                                    value={props.attributes[attribute]}
                                    sliderChange = {props.sliderChange}/>
                    ))}
                </div>
                <div className='flex-inline md:ml-2 pr-3 mt-6 -space-y-2'>
                    {att.slice(18).map((attribute, index)=>(
                        <SliderSolo key={index}
                                    name={attribute}
                                    value={props.attributes[attribute]}
                                    sliderChange = {props.sliderChange}/>
                    ))}
                </div>
            </div>
        // </div>

     );
}

export default KnobSet;
